var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _circle2, _circle3, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTimeline4Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3005 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6404 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.98 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.68 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.98 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.66 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 20V420",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 20H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 53.1567H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 86.3528H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 119.549H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 152.745H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 185.941H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 219.137H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 252.333H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 285.529H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 318.686H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 351.881H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 385.078H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 418.273H20",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 92.2546,
    width: 246.5,
    height: 307.245,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.75,
    y: 295.875,
    width: 105.875,
    height: 55.25,
    rx: 4.5,
    stroke: "#252525"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.875,
    y: 295.875,
    width: 105.875,
    height: 55.25,
    rx: 4.5,
    fill: "#252525",
    stroke: "#252525"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 234,
    width: 201.5,
    height: 10.25,
    rx: 0.5,
    stroke: "#252525"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 169.625,
    y: 256.5,
    width: 100.25,
    height: 10.25,
    rx: 0.5,
    stroke: "#252525"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.531,
    y: 363.156,
    width: 100.688,
    height: 0.5625,
    stroke: "#252525",
    strokeWidth: 0.5625
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107.531,
    y: 369.906,
    width: 44.4375,
    height: 0.5625,
    stroke: "#252525",
    strokeWidth: 0.5625
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107.531,
    y: 376.656,
    width: 44.4375,
    height: 0.5625,
    stroke: "#252525",
    strokeWidth: 0.5625
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 246.5,
    height: 44,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 96 84)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.182,
    cy: 62.3366,
    r: 5.95643,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.03,
    cy: 62.3366,
    r: 5.95643,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.877,
    cy: 62.3366,
    r: 5.95643,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.082 165.898C225.559 165.241 220.491 160.196 219.852 121.668H219.648C218.992 160.196 213.947 165.259 175.418 165.898V166.102C213.947 166.758 219.009 171.809 219.648 210.337H219.852C220.509 171.809 225.559 166.747 264.082 166.102V165.898Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.508 211.006H218.992V210.343C218.678 191.779 217.353 180.568 211.273 174.488C205.194 168.409 193.971 167.09 175.407 166.77L174.75 166.758V165.241H175.407C193.971 164.922 205.182 163.596 211.261 157.517C217.341 151.438 218.666 140.22 218.98 121.657V121H220.497V121.657C220.84 140.22 222.165 151.432 228.221 157.511C234.277 163.591 245.512 164.916 264.076 165.235H264.733V166.752H264.076C245.529 167.09 234.318 168.415 228.221 174.471C222.124 180.527 220.84 191.779 220.52 210.343L220.508 211.006ZM189.123 166.003C200.166 166.863 207.542 168.862 212.226 173.558C216.911 178.255 218.904 185.63 219.782 196.661C220.642 185.618 222.642 178.237 227.338 173.558C232.034 168.88 239.404 166.874 250.441 166.003C239.398 165.137 232.016 163.137 227.338 158.447C222.659 153.757 220.654 146.375 219.782 135.344C218.916 146.387 216.917 153.762 212.226 158.447C207.536 163.132 200.137 165.137 189.106 166.003H189.123Z",
    fill: "#252525"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_243_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 302.5H80",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 313V292",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4999 296.876C69.1947 298.198 68.543 299.416 67.6116 300.403C66.6802 301.39 65.5027 302.112 64.2002 302.493C64.2002 302.493 68.8374 304.269 69.533 308.522C69.533 308.522 70.6261 302.493 75.6608 302.493C75.6276 302.493 71.0633 302.845 69.4999 296.876Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_243_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.09 141.694H178.636",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.863 149.467V133.921",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.863 137.53C170.637 138.509 170.155 139.411 169.465 140.141C168.776 140.872 167.904 141.407 166.94 141.689C166.94 141.689 170.373 143.003 170.888 146.152C170.888 146.152 171.697 141.689 175.424 141.689C175.399 141.689 172.02 141.949 170.863 137.53Z",
    fill: "#252525"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_243_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.91 274.995H158.456",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 282.768V267.222",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 270.832C150.457 271.811 149.975 272.712 149.285 273.443C148.596 274.174 147.724 274.708 146.76 274.99C146.76 274.99 150.193 276.305 150.708 279.453C150.708 279.453 151.517 274.99 155.244 274.99C155.22 274.99 151.841 275.25 150.683 270.832Z",
    fill: "#252525"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_243_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.815 49.5808H196.361",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.588 57.3539V41.8076",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.588 45.417C188.362 46.3961 187.88 47.2973 187.19 48.0282C186.501 48.7591 185.629 49.2932 184.665 49.5757C184.665 49.5757 188.098 50.8901 188.613 54.0385C188.613 54.0385 189.422 49.5757 193.149 49.5757C193.124 49.5757 189.746 49.8357 188.588 45.417Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.444 106.238H373.991",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.218 114.011V98.4644",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.218 102.074C365.992 103.053 365.509 103.954 364.82 104.685C364.13 105.416 363.258 105.95 362.294 106.232C362.294 106.232 365.727 107.547 366.242 110.695C366.242 110.695 367.051 106.232 370.778 106.232C370.754 106.232 367.375 106.492 366.218 102.074Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.143 349.413L334.795 316.127",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.611 361.596L289.326 303.944",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.054 317.33C298.313 321.444 298.453 325.819 297.461 330.006C296.469 334.193 294.38 338.04 291.409 341.152C291.409 341.152 306.953 338.676 315.604 349.249C315.604 349.249 309.05 330.967 322.872 322.987C322.781 323.039 310.807 331.238 297.054 317.33Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.798 377.144L335.412 381.598C334.519 381.71 333.704 382.181 333.16 382.898L315.116 405.251C315.115 405.252 315.115 405.253 315.114 405.254C314.565 405.918 313.729 406.036 312.866 405.601C311.987 405.159 311.227 404.185 311.137 402.92L311.136 402.909L305.657 336.06L305.656 336.05L305.655 336.039C305.554 335.054 305.964 334.401 306.469 334.103C306.968 333.808 307.742 333.752 308.601 334.354L308.606 334.357L363.741 372.52C364.792 373.289 365.251 374.473 365.194 375.458C365.141 376.376 364.684 376.97 363.958 377.119L363.798 377.144Z",
    fill: "#252525",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90.0058,
    fill: "white",
    transform: "translate(174.75 121)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_243_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(59 292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_243_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(163.09 133.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_243_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(142.91 267.222)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_243_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(180.815 41.8076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTimeline4Image);
export default __webpack_public_path__ + "static/media/landing-timeline-4-image.635e7a1cbca8651044010508ed1389c9.svg";
export { ForwardRef as ReactComponent };